module.exports = __webpack_public_path__ + "img/IMG_1231_L_Wood.c8f78393.jpg";